import React from "react";

export const enquiryColumns = ({
  PAGE_SIZE,
  onViewDetails,
  onEdit,
  handleDelete,
  onSelectRow,
  selectedIds = [],
  allSelected = false,
  onSelectAll = null,
}) => {
  const cols = [];

  if (onSelectRow) {
    cols.push({
      label: onSelectAll ? (
        <input
          type="checkbox"
          checked={allSelected}
          onChange={onSelectAll}
          style={{ cursor: "pointer", width: "15px", height: "15px" }}
          title="Select all"
        />
      ) : (
        ""
      ),
      width: 45,
      render: (row) => (
        <div className="text-center">
          <input
            type="checkbox"
            checked={selectedIds.includes(row._id)}
            onChange={() => onSelectRow(row._id)}
            style={{ cursor: "pointer", width: "15px", height: "15px" }}
          />
        </div>
      ),
    });
  }

  cols.push(
    {
      label: "S.No",
      width: 55,
      render: (row, index, page) => (
        <span
          className="badge"
          style={{
            backgroundColor: "#f3f4f6",
            color: "#4b5563",
            fontSize: "12px",
            padding: "5px 8px",
            fontWeight: "600",
            borderRadius: "4px",
            border: "1px solid #e5e7eb",
          }}
        >
          #{(page - 1) * PAGE_SIZE + index + 1}
        </span>
      ),
    },
    {
      label: "Date",
      width: 130,
      render: (row) => {
        if (!row.createdAt) return <span>-</span>;
        const d = new Date(row.createdAt);
        const dateStr = d.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
        const timeStr = d.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

        return (
          <div style={{ lineHeight: "1.3" }}>
            <span style={{ fontWeight: "600", color: "#2d3748", fontSize: "13px" }}>
              {dateStr}
            </span>
            <div style={{ fontSize: "11px", color: "#718096", marginTop: "2px" }}>
              <i className="fa fa-clock-o" style={{ marginRight: "3px" }}></i>
              {timeStr}
            </div>
          </div>
        );
      },
    },
    {
      label: "Member Details",
      width: 250,
      whiteSpace: "normal",
      render: (row) => {
        return (
          <div className="userdet" style={{ fontSize: "13px", lineHeight: "1.4" }}>
            {/* Name */}
            <div
              style={{
                fontWeight: "600",
                color: "#1a202c",
                marginBottom: "3px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <i
                className="fa fa-user"
                style={{
                  color: "#bf3272",
                  marginRight: "6px",
                  fontSize: "12px",
                  width: "14px",
                }}
              ></i>
              <span>{row.name || "N/A"}</span>
            </div>

            {/* Mobile */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "3px",
                color: "#4a5568",
              }}
            >
              <i
                className="fa fa-mobile"
                style={{
                  color: "#bf3272",
                  marginRight: "6px",
                  fontSize: "15px",
                  width: "14px",
                  textAlign: "center",
                }}
              ></i>
              <a
                href={row.mobile ? `tel:${row.mobile}` : undefined}
                style={{ color: "#3182ce", textDecoration: "none" }}
              >
                {row.mobile || "-"}
              </a>
            </div>

            {/* Email */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                color: "#718096",
                wordBreak: "break-all",
              }}
            >
              <i
                className="fa fa-envelope"
                style={{
                  color: "#bf3272",
                  marginRight: "6px",
                  fontSize: "11px",
                  width: "14px",
                  textAlign: "center",
                }}
              ></i>
              {row.email ? (
                <a
                  href={`mailto:${row.email}`}
                  style={{ color: "#4a5568", textDecoration: "none", fontSize: "12px" }}
                >
                  {row.email}
                </a>
              ) : (
                "-"
              )}
            </div>
          </div>
        );
      },
    },
    {
      label: "Enquiry For",
      width: 170,
      whiteSpace: "normal",
      render: (row) => (
        <span
          className="badge"
          style={{
            backgroundColor: "#fdf2f8",
            color: "#be185d",
            border: "1px solid #fbcfe8",
            padding: "5px 10px",
            borderRadius: "14px",
            fontWeight: "500",
            fontSize: "12px",
            display: "inline-block",
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          title={row.enquiry_for}
        >
          {row.enquiry_for || "General"}
        </span>
      ),
    },
    {
      label: "Message",
      width: 270,
      whiteSpace: "normal",
      render: (row) => {
        const msg = row.message || "-";
        const isLong = msg.length > 70;
        return (
          <div style={{ fontSize: "12.5px", color: "#374151" }}>
            <span
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                lineHeight: "1.4",
              }}
              title={msg}
            >
              {msg}
            </span>
            {isLong && onViewDetails && (
              <button
                type="button"
                onClick={() => onViewDetails(row)}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  fontSize: "11.5px",
                  color: "#bf3272",
                  fontWeight: "600",
                  cursor: "pointer",
                  marginTop: "2px",
                }}
              >
                Read more &raquo;
              </button>
            )}
          </div>
        );
      },
    },
    {
      label: "Action",
      width: 105,
      render: (row) => {
        return (
          <div className="d-flex align-items-center justify-content-center" style={{ gap: "5px" }}>
            {/* View Details Button */}
            {onViewDetails && (
              <button
                type="button"
                className="btn btn-sm"
                onClick={() => onViewDetails(row)}
                title="View full details"
                style={{
                  backgroundColor: "#eff6ff",
                  color: "#2563eb",
                  border: "1px solid #bfdbfe",
                  borderRadius: "5px",
                  padding: "4px 7px",
                  fontSize: "12px",
                  cursor: "pointer",
                }}
              >
                <i className="fa fa-eye"></i>
              </button>
            )}

            {/* Edit Button */}
            {onEdit && (
              <button
                type="button"
                className="btn btn-sm"
                onClick={() => onEdit(row)}
                title="Edit enquiry"
                style={{
                  backgroundColor: "#fffbeb",
                  color: "#d97706",
                  border: "1px solid #fde68a",
                  borderRadius: "5px",
                  padding: "4px 7px",
                  fontSize: "12px",
                  cursor: "pointer",
                }}
              >
                <i className="fa fa-pencil"></i>
              </button>
            )}

            {/* Delete button */}
            {handleDelete && (
              <button
                type="button"
                className="btn btn-sm"
                onClick={() => handleDelete(row._id)}
                title="Delete enquiry"
                style={{
                  backgroundColor: "#fef2f2",
                  color: "#dc2626",
                  border: "1px solid #fecaca",
                  borderRadius: "5px",
                  padding: "4px 7px",
                  fontSize: "12px",
                  cursor: "pointer",
                }}
              >
                <i className="fa fa-trash"></i>
              </button>
            )}
          </div>
        );
      },
    }
  );

  return cols;
};
